import enUS from './en-us'
import es from './es'

export default {
  'en-US': enUS,
  es
}
